import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'flattenDeliverySurcharges',
  initialState: false,
  reducers: {
    setFlattenDeliverySurcharges(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setFlattenDeliverySurcharges } = slice.actions;

export default slice.reducer;
